<template>
  <component
    :is="componentName"
    v-if="type"
    :key="route"
    :nid="parseInt(nid)"
  />
</template>

<script>

import applogger from '@applogger'
import { NotFoundError } from 'app/errors'

const gqlDoc = `
  query faqs {
    winefaqlist {
      id
      status
      created
      featured
      title
      body
      category
    }
  }
`

export default {
  name: 'catch-all',
  headData: true,
  headTitle() {
    return this.title
  },
  asyncData: ({store, router, route, app}) => {
    if (!route) return Promise.resolve(true)
    const __loader = () => {
      applogger.debug(`catch-all asyncData starting: ${route.path}`)

      const product = store.getters['products/findByRoutePath'](route.path)
      if (product && typeof product === 'object' && Object.prototype.hasOwnProperty.call(product, 'id')) {
        product._isProduct = true
      }
      let init = Promise.resolve(product)
      if (!product || !product._isProduct) {
        init = store.dispatch('node/lookupItem', {path: route.path})
      }

      return init
        .then(iteminfo => {
          const blobsToLoad = [
            `page-blob-top--node-${iteminfo.id}`,
            `page-blob-bottom--node-${iteminfo.id}`
          ]

          const initialRequests = [
            store.dispatch('node/load', {nid: iteminfo.id, type: iteminfo.type, cacheOptions: {scope: 'global'}}),
            store.dispatch('blob/loadgroup', {blobIDs: blobsToLoad, cacheOptions: { scope: 'global', ttl: 3600 * 12 }})
          ]

          if (iteminfo._isProduct) {
            if (Object.prototype.hasOwnProperty.call(iteminfo, 'images') && iteminfo.images.length > 0) {
              const destructuredImageData = iteminfo.images.map((image) => image.image)
              const images = Object.values(destructuredImageData).map(file => ({ ...file, preset: 'wineproductdetails' }))
              initialRequests.push(store.dispatch('filestore/getFileURLBulk', { files: images }))
            }

            const gqlClient = store.getters.getGraphQLClient(null, gqlDoc)
            const list = store.getters['list/get']('winefaqs', 'default')
            if (!list) {
              initialRequests.push(gqlClient.query({ opName: 'faqs' }).then(response => {
                if (response && response.data && response.data.winefaqlist) {
                  return store.dispatch('list/storeList', {
                    view: 'winefaqs',
                    display: 'default',
                    list: { data: response.data.winefaqlist }
                  })
                }
              }))
            }
          }
          return Promise.all(initialRequests).then(results => results[0])
        })
        .then(node => {
          if (!node) {
            throw new NotFoundError(`Unable to load Item: ${route.path}`)
          }
          return new Promise((resolve, reject) => {
            const __componentLoader = (counter) => {
              const loader = router.app.$options.components[`page-content-type-${node.type}`].call()
              if (typeof loader.component.then === 'function') {
                resolve(loader.component)
              }
              else if (counter < 3) {
                setTimeout(() => __componentLoader(counter + 1), 250)
              }
              else {
                reject(new NotFoundError(`Unable to locate component ${node.type}`))
              }
            }
            __componentLoader(0)
          })
            .then(component => {
              return app.loadAsyncData([component.default], route)
            })
        })
        .then(_ => {
          applogger.debug('catch-all asyncData completed')
        })
    }
    return store.dispatch('promisePool',
      {
        name: `catch-all--${route.path}`,
        resolve: __loader
      }
    )
  },
  data: function() {
    return {
      nid: null,
      type: null,
      title: ''
    }
  },
  computed: {
    componentName: function() {
      return `page-content-type-${this.type}`
    },
    route: function() {
      return this.$route.fullPath
    }
  },
  watch: {
    route: {
      immediate: true,
      handler: function() {
        let node
        if (this.$route.params.nid !== undefined && !isNaN(parseFloat(this.$route.params.nid)) && isFinite(this.$route.params.nid)) {
          node = this.$store.getters['node/getByNID'](this.$route.params.nid)
        }
        else {
          node = this.$store.getters['node/getByPath'](this.$route.path)
        }
        if (!node) {
          this.$store.commit('SET_PAGE_SETTING', { key: 'error', value: 404 })
          return
        }
        this.nid = node.nid
        this.type = node.type
        this.title = node.title
      }
    }

  }
}
</script>

<style lang='scss' scoped>
</style>
